var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8997 35.42C38.584 36.1025 38.584 37.2226 37.8997 37.9051C37.2172 38.5876 36.1078 38.5876 35.4235 37.9051L28.0105 30.4851L20.545 37.9574C19.8555 38.6399 18.739 38.6399 18.0495 37.9574C17.3618 37.2574 17.3618 36.1375 18.0495 35.455L25.515 27.9825L18.102 20.58C17.4177 19.8975 17.4177 18.7774 18.102 18.0949C18.7827 17.4124 19.8922 17.4124 20.5765 18.0949L27.9895 25.5149L35.511 17.9901C36.2005 17.3076 37.3152 17.3076 38.0047 17.9901C38.6925 18.6901 38.6925 19.7924 38.0047 20.4924L30.485 28.0175L37.8997 35.42ZM28 0C12.5353 0 0 12.53 0 28C0 43.47 12.5353 56 28 56C43.4647 56 56 43.47 56 28C56 12.53 43.4647 0 28 0Z",
    fill: "#FF3D00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedLogo);
export default __webpack_public_path__ + "static/media/failed-logo.b6a02dea10d981e14e4bdad452bf4d82.svg";
export { ForwardRef as ReactComponent };